import React from 'react';
import { Counter } from '../counter';

const ViewCount = (props) => <Counter {...props} i18nKey="view-count.label" />;

export default ViewCount;
